import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7944ee84"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Title", -1))
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "expand editor-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description", -1))
const _hoisted_6 = ["text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_MentionableEditor = _resolveComponent("MentionableEditor")!
  const _component_WebViewForm = _resolveComponent("WebViewForm")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    title: "New Suggestion",
    "no-pad": ""
  }, {
    "left-button": _withCtx(() => [
      _createVNode(_component_BackButton)
    ]),
    "right-button": _withCtx(() => [
      _createElementVNode("div", {
        class: "submit",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitSuggestion && _ctx.submitSuggestion(...args)))
      }, [
        _createElementVNode("button", {
          disabled: !_ctx.submittable || _ctx.isSubmitting
        }, _toDisplayString(!_ctx.isSubmitting ? 'Post' : 'Posting'), 9, _hoisted_1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_WebViewForm, {
        class: "suggestion-composer",
        onSubmit: _ctx.submitSuggestion
      }, {
        default: _withCtx(() => [
          _createElementVNode("fieldset", null, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                class: "editor-title",
                placeholder: "Suggestion title"
              }, null, 512), [
                [_vModelText, _ctx.title]
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_MentionableEditor, {
              members: _ctx.suggestionMentionUsers,
              placeholder: "Write suggestion description",
              text: _ctx.body,
              onInput: _ctx.onInputChange,
              onMention: _ctx.onMention
            }, null, 8, ["members", "text", "onInput", "onMention"])
          ]),
          _createElementVNode("input", {
            text: _ctx.mentions,
            class: "mentions"
          }, null, 8, _hoisted_6)
        ], undefined, true),
        _: 1
      }, 8, ["onSubmit"])
    ], undefined, true),
    _: 1
  }))
}